<template>
  <div class="catalogue-load-more catalogue-pagination normal arial centered light" v-if="pages > 1 && activeIndex < pages" ref="scrollReference">
  </div>
</template>

<script>
export default {
  props: ['results', 'isLoading'],

  data() {
    return {
      activeIndex: -1,
      pages: 0,
      scrolled: false,
      hasNotified: false,
      isEventBound: false
    }
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  watch: {
    results: function(newVal, oldVal) {
      this.update(newVal);
    },

    scrolled: function() {
      if(!this.isLoading && !this.hasNotified) {
        this.notify();
        this.hasNotified = true;
        this.unbind();
      }
    },

    isLoading: function(newVal, oldVal) {
      if(newVal) {
        setTimeout(() => this.hasNotified = false, 1000);
      } else {
        this.bind();
      }
    }
  },

  methods: {
    bind: function() {
      if(!this.isEventBound) {
        window.addEventListener('scroll', this.handleScroll);
        this.isEventBound = true;
      }
    },

    unbind: function() {
      window.removeEventListener('scroll', this.handleScroll);
      this.isEventBound = false;
    },

    update: function(results) {
      this.pages = results.last_page;
      this.activeIndex = results.current_page;
    },

    notify: function() {
      this.$eventBus.$emit('navpage:update', this.activeIndex+1);
    },

    handleScroll () {
      let t;
      if(this.$refs.scrollReference) t = this.$refs.scrollReference.offsetTop;
      this.scrolled = ((window.scrollY || window.pageYOffset) + window.innerHeight) > t;
    }
  }
}
</script>

<style lang="scss" scoped>
.active {
  text-decoration: underline;
}

ul {
  @util reset-list;
}
</style>


// WEBPACK FOOTER //
// src/vue/components/CatalogResultsNavigation.vue